import { Component, inject } from '@angular/core';
import { SafeScriptComponent } from '../../script-injector/safe-script/safe-script.component';
import { SurveyRenderControllerStore } from '../../render-store/render.store';
import { UnifiedSurveyStore } from '../../render-store/unified-survey.store';

@Component({
  selector: 'lib-survey-completed',
  imports: [SafeScriptComponent],
  templateUrl: './survey-completed.html',
  styleUrl: './survey-completed.css',
})
export class SurveyCompleted {
  renderStore = inject(SurveyRenderControllerStore);
  surveyBotController = inject(UnifiedSurveyStore);

  goBack() {
    return this.surveyBotController.onSwitchQuestionClick(false);
  }
}
